import {BaseEntityConfig, WhiteListFields} from '~/redux/base-entity-config';
import {AdminEntity} from '~/types/models/admin';

class EntityConfig extends BaseEntityConfig<AdminEntity> {
  entityKey = 'admins';

  associates = [];

  whiteListFields: WhiteListFields<AdminEntity> = ['*'];

  getAccessors = (value: AdminEntity) => {
    //
  };
}

const adminEntConf = new EntityConfig();

export const adminSchema = adminEntConf.getEntitySchema();

export default adminEntConf;

export const SOURCES_ADMIN = {
  ADMINS_PAGE: 'ADMINS_PAGE',
};
